import { type FC } from "react";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";
import deleteImg from "@/assets/icon/delete.svg";
import { Pressable } from "./Pressable";

const keyArr = [
  "1",
  "2",
  "3",
  "delete",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
  "submit",
];

export const VirtualKeyboard: FC<{
  value?: string;
  onChange: (value?: string) => void;
  onSubmit: () => void;
  type?: "number" | "string";
  maxLength?: number;
}> = ({ value, onChange, onSubmit, type = "number", maxLength }) => {
  const handleNumber = (key: string) => {
    const num = Number(value);
    if (key === "delete") {
      const newValue = Math.floor((num || 0) / 10);
      onChange(newValue ? String(newValue) : undefined);
    } else if (key === "submit") {
      onSubmit();
    } else {
      const newValue = (num ?? 0) * 10 + Number(key);
      onChange(newValue > 99 ? String(99) : String(newValue));
    }
  };

  const handleString = (key: string) => {
    if (key === "delete") {
      const newValue = value?.slice(0, -1);
      onChange(newValue || undefined);
    } else if (key === "submit") {
      onSubmit();
    } else {
      const newValue = `${value ?? ""}${key}`;
      onChange(
        !maxLength || newValue.length <= maxLength
          ? newValue
          : newValue.slice(0, maxLength),
      );
    }
  };

  const { t } = useTranslation();

  return (
    <div className="border-color-border grid w-full grid-cols-[repeat(4,1fr)] grid-rows-[repeat(4,64px)] border text-xl font-normal">
      {keyArr.map((key) => (
        <Pressable
          key={key}
          className={twMerge(
            "border-color-border flex items-center justify-center cursor-pointer",
            !["delete", "submit"].includes(key) ? "border-r" : "",
            !["0", "submit"].includes(key) ? "border-b" : "",
            key === "0" ? "col-span-3 row-start-4" : "",
            key === "submit"
              ? "bg-color-primary col-start-4 row-start-2 row-end-5 text-white hover:bg-color-primary-7 active:bg-color-primary-7"
              : "hover:bg-color-fill active:bg-color-fill",
          )}
          onPress={() => {
            type === "number" ? handleNumber(key) : handleString(key);
          }}
        >
          {key === "delete" ? (
            <img src={deleteImg} className="size-[26px] text-[red]" />
          ) : key === "submit" ? (
            t("confirm")
          ) : (
            key
          )}
        </Pressable>
      ))}
    </div>
  );
};
